var React = require('react');

function Terminal (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M640 421.34v32a24 24 0 0 1-24 24H312a24 24 0 0 1-24-24v-32a24 24 0 0 1 24-24h304a24 24 0 0 1 24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M29.7 464.66L7 442a24 24 0 0 1 0-33.9l154-154.76L7 98.6a24 24 0 0 1 0-33.9L29.7 42a24 24 0 0 1 33.94 0L258 236.37a24 24 0 0 1 0 33.94L63.64 464.66a24 24 0 0 1-33.94 0z","className":"fa-primary","key":2})]);
}

Terminal.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Terminal;

Terminal.default = Terminal;
